/**
 * Identifikátor registrovaného typu
 * @includeToDoc
 */
export type TypeIdentifier<T> = string | symbol | { new(...params: any[]): T;[Symbol.hasInstance]: (i: any) => boolean };
